import { useContext, useState } from 'react'
import { useTranslation } from 'react-i18next'

import { ScrollableTabs, Switch, Text, TextAreaRichEditor } from '@reveni-io/reveni-ui'

import { languages as constantsLanguage } from '@/common/constants'
import AppContext from '@/common/context/app.context'
import { getCurrentAvailableLanguage } from '@/configuration/helpers/helpers'
import BlockingMessage from '@/configuration/pages/ConfigurationPage/ReturnReasonsConfiguration/ReturnReasonDetailConfiguration/BlockingMessage/BlockingMessage'

import { actionTypeValues } from '../constants'
import useCustomMessageText from './hooks/useCustomMessageText/useCustomMessageText'
import * as Styles from './styles'

const CustomMessage = ({
  languages,
  useCustomMessage,
  onCheckUseCustomMessage,
  customMessages,
  onChangeCustomMessage,
  action,
  actionForTransactionTypes,
}) => {
  const { info } = useContext(AppContext)
  const { t, i18n } = useTranslation()
  const supportedLanguages = info?.selectedStore?.supported_languages || ['en']
  const currentLanguage = getCurrentAvailableLanguage(supportedLanguages, i18n.language)
  const [textLanguage, setTextLanguage] = useState(currentLanguage)
  const { handleChangeCustomMessage, handleOnBlurMessage, messageErrors } = useCustomMessageText({
    onChangeCustomMessage,
  })

  const getLanguageLabel = language => {
    return constantsLanguage(t).find(lang => lang.value === language)?.label
  }

  return (
    <Styles.Container>
      <Text type="titleS">{t('Mensaje personalizado')}</Text>
      <Switch
        checked={useCustomMessage}
        onChange={onCheckUseCustomMessage}
        label={t('Mostrar mensaje personalizado cuando se seleccione este motivo')}
        disabled={actionForTransactionTypes?.length > 0 && action === actionTypeValues.block}
      />
      {useCustomMessage && (
        <Styles.TranslationContainer>
          <BlockingMessage
            action={action}
            actionForTransactionTypes={actionForTransactionTypes}
            message={t(
              'Si la selección de este motivo bloquea el proceso, es obligatorio mostrar un mensaje personalizado'
            )}
          />
          <div>
            <ScrollableTabs
              tabs={languages.map(language => ({
                label: getLanguageLabel(language),
                value: language,
                error: messageErrors?.[language],
              }))}
              value={textLanguage}
              onChange={setTextLanguage}
            />
            <TextAreaRichEditor
              onChange={data => handleChangeCustomMessage(data, textLanguage)}
              value={customMessages?.[textLanguage]}
              onBlur={handleOnBlurMessage}
              minHeight="56px"
              fullWidth
              key={textLanguage}
              richEditorTheme="bubble"
              richEditorToolbarModules={['bold', 'italic', 'link']}
              textType="html"
            />
          </div>
        </Styles.TranslationContainer>
      )}
    </Styles.Container>
  )
}

export default CustomMessage
